<template>
    <div class="continer">
        <background>
            <div class="cancle-btn" @click="goBack">返回上一步</div>
            <div v-if="step === 1">
                <div class="title">第一步：<span>身份验证</span></div>
                <el-form class="login-form" :model="loginForm" :rules="rules" ref="loginForm">
                    <div class="login-tips">请使用{{loginWayInfo.name}}账号进行验证</div>
                    <el-form-item prop="username">
                        <el-input v-model="loginForm.username" placeholder="请输入账户名">
                        <img class="input-icon" slot="prefix" src="@/assets/images/busImage/user.png">
                        </el-input>
                    </el-form-item>
                    <el-form-item prop="password">
                        <el-input v-model="loginForm.password" placeholder="请输入密码" type="password">
                            <img class="input-icon" slot="prefix" src="@/assets/images/busImage/unlock.png">
                        </el-input>
                    </el-form-item>
                    <div class="code-box">
                        <el-form-item class="code-box-item"  prop="code">
                            <el-input v-model="loginForm.code" placeholder="请输入验证码">
                                <img class="input-icon" slot="prefix" src="@/assets/images/busImage/key.png">
                            </el-input>
                        </el-form-item>
                        <img class="code-image" @click="getCodeInfo" :src="codeInfo.showUrl">
                    </div>
                    <div class="submit-button" @click="handleLogin">确 认</div>
                </el-form>
            </div>
            <div v-if="step === 2">
                <div class="title">第二步：<span>人像采集</span></div>
                <div>
                    <!-- 图像列表 -->
                    <div class="image-list">
                        <div class="image-item" v-for="(item,index) in imageList" :key="index">
                            <div v-if="item.url" class="face-image">
                                <el-image
                                    style="width: 100%; height: 100%"
                                    :src="item.url"
                                    fit="contain"></el-image>
                                <img @click="deleteImage(index)" class="delete-icon" src="@/assets/images/busImage/delete_red.png"/>    
                            </div>
                            <div v-else  class="wait-add-image">
                                <img class="add-icon" src="@/assets/images/busImage/plus_square.png">
                            </div>
                        </div>
                        <div class="num-tips"><i class="el-icon-warning-outline"></i>最多拍照5张</div>
                    </div>
                    <!-- 识别模块 -->
                    <div class="identify-content">
                        <div class="identify-block">
                            <div class="external-block"></div>
                            <img  ref="camera" class="image-block">
                            <div v-if="isShowCountdown" class="countdown-number">{{ count }}</div>
                        </div>
                        <div class="tips">
                            <div class="tips-info">{{tipsText}}</div>
                            <div class="tips-list">
                                <div class="item" v-for="(item,index) in tipsList" :key="index">
                                    <img class="item-icon" :src="item.icon"/>
                                    <div class="item-text">{{item.text}}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div v-if="step === 2" class="btn-group">
                <div v-if="isShowCamera" class="other-login" @click="takePhoto">拍 照</div>
                <div class="retry-btn" @click="gatherFinish">采集完毕</div>
            </div>
        </background>
    </div>
</template>

<script>
import background from '@/components/background'
import cameraMixin from '@/mixin/cameraMixin'
import { faceBind, getListFaceData,getCode,getFaceInputLoginWay } from '@/api/user'
export default {
    components: {
        background
    },
    mixins: [cameraMixin],
    data(){
        return {
            step: 1,
            imageList: [{},{},{},{},{}],
            loginForm: {
                username: "",
                password: ""
            },
            rules: {
                username: [
                    { required: true, message: '请输入账户名', trigger: 'blur' },
                ],
                password: [
                    { required: true, message: '请输入密码', trigger: 'blur' },
                ]
            },
            codeInfo:{},
            loginWayInfo:{},
            // 倒计时
            isShowCountdown: false,
            count:3,
            // 图像采集
            isTakePhotoSuccess: false,
            photo_color:"",
            photo_base64:"",
            photo_infrared:"",
            tipsText: '正在进行人像采集',
            tipsList: [
                {   
                    icon: require('@/assets/images/busImage/eye.png'),
                    text:'避免遮挡'
                },
                {
                    icon: require('@/assets/images/busImage/light.png'),
                    text:'光线充足'
                },
                {
                    icon: require('@/assets/images/busImage/phone.png'),
                    text:'正对屏幕'
                }
            ]
        }
    },
    beforeDestroy(){
        this.closePage()
    },
    computed:{
        isShowCamera(){
            let takePhotoNum = (this.imageList.filter(item => item.url)).length
            return takePhotoNum <5
        }
    },
    mounted(){
        this.getFaceInputLoginWayInfo()
    },
    methods: {
        getFaceInputLoginWayInfo(){
            getFaceInputLoginWay().then(res => {
                if(res.code === 200){
                    this.loginWayInfo = res.data || {}
                    this.getCodeInfo()
                }
            })
        },
        getCodeInfo(){
            let loginWay = this.loginWayInfo.id
            if(!loginWay) return 
            getCode({loginWay}).then(res => {
                if(res.code === 200){
                    this.codeInfo = res.data || {}
                    this.codeInfo.showUrl = 'data:image/jpeg;base64,' + res.data.img
                }
            })
        },
        handleLogin(){
            this.submitLogin()
        },
        
        submitLogin(){
            this.$refs.loginForm.validate((valid) => {
                if (valid) {
                    let loginForm = {
                        ...this.loginForm,
                        loginWay:this.$route.query.loginWay,
                        uuid: this.codeInfo.uuid 
                    }
                    this.$store.dispatch('Login',loginForm).then(() => {
                        this.step = 2
                        this.getFaceData()
                        this.$nextTick(() => {
                            this.openCamera()
                        })
                    }).catch(() => {
                        this.getCodeInfo()
                    })
                    
                } else {
                    return false;
                }
            });
        },
        
        // 获取已绑定的人脸信息
        getFaceData(){
            getListFaceData().then(res => {
                if(res.code === 200){
                    let list = res.data || []
                    list.forEach((item,index) => {
                        let obj = {}
                        obj.url = "data:image/jpeg;base64,"+item
                        obj.imageBase64 = item
                        this.$set(this.imageList,index,obj)
                    })
                }
            })
        },
        // 打开摄像头openCamera
        async openCamera(){
            const ele = this.$refs.camera;
            await this.startCamera(ele)
        },
        takePhoto(){
            this.isShowCountdown = true
            this.curIndex++  // 获取当前拍的是第几张
            this.startCountdown()
        },
        startCountdown() {
            if (this.count > 0) {
                setTimeout(() => {
                this.count--; // 每秒减少1秒
                this.startCountdown(); // 递归调用以继续倒计时
                }, 1000); // 每1000毫秒（1秒）执行一次
            } else {
                // 倒计时结束后的操作，例如重置或停止等
                this.isShowCountdown = false
                this.startLiveCamera()
                this.count = 3
                console.log('倒计时结束');
            }
        },
        startLiveCamera(){
            this.liveCapture().then(result => {
                let photo_color = "data:image/jpeg;base64,"+result.face_image_base64;
                // 抓取图像显示
                let curIndex = (this.imageList.filter(item => item.url)).length
                this.$set(this.imageList[curIndex],'url', photo_color)
                this.$set(this.imageList[curIndex],'imageBase64', result.face_image_base64)
                this.photo_base64 = result.face_image_base64;
                this.photo_infrared = "data:image/jpeg;base64,"+result.infrared_face_image_base64;
                this.cancelPhotos()
            })
        },
        deleteImage(index){
            this.imageList.splice(index, 1);
            this.imageList.push({url:''})
        },
        gatherFinish(){
            let face = []
            this.imageList.forEach(item => {
                if(item.imageBase64){
                    face.push(item.imageBase64)
                }
            })
            faceBind({face:face}).then(res => {
                if(res.code === 200){
                    this.$router.push({name: 'start'})
                }
            })
        },
        // 关闭页面
        closePage(){
            this.cancelPhotos().then(res => {
                this.stopCamera().then(res => {
                })
            })
        },
        goBack(){
            this.$router.go(-1)
        }
    }

}
</script>

<style lang="less" scoped>
    .continer {
        height: 100%;
        width: 100%;
        overflow: hidden;
    }
    .title {
        margin-top: 67px;
        margin-left: 131px;
        font-weight: 400;
        font-size: 48px;
        color: #B23B34;
        line-height: 67px;
        letter-spacing: 2px;
        span {
            font-weight: 600;
        }
    }
    .login-tips {
        margin: 20px 0;
        font-size: 25px;
        font-weight: 600;
        color: #B23B34;
    }
    .login-form {
            margin: 68px auto 0 657px;
            /deep/ input {
                width: 527px;
                height: 80px;
                box-sizing: border-box;
                padding-left: 80px;
                border-radius: 6px;
                border: 2px solid #FFD6DC;
                font-size: 26px;
            }
            /deep/ .el-form-item__content{
                width: 527px;
                height: 80px;
                margin-bottom: 32px;
            }
            /deep/ .el-input__prefix{
                display: flex;
                align-items: center;
            }
            /deep/ .el-form-item__error{
                font-size: 16px;
            }
            /deep/ .code-box-item  input{
                width: 377px;
                height: 80px;
                box-sizing: border-box;
                padding-left: 80px;
                border-radius: 6px;
                border: 2px solid #FFD6DC;
                font-size: 26px;
            }
            /deep/ .code-box-item .el-form-item__content{
                width: 377px;
                height: 80px;
            }
    }
    .input-icon {
        height: 40px;
        width: 40px;
        margin-left: 13px;
    }
    .code-box {
            display: flex;
        }
        .code-image {
            width: 140px;
            height: 80px;
            margin-left: 10px;
        }

    .submit-button {
            width: 527px;
            height: 80px;
            line-height: 80px;
            background: linear-gradient( 135deg, #C62D2F 0%, #B23B34 100%);
            box-shadow: 0px 2px 4px 0px rgba(255,12,55,0.07);
            border-radius: 8px;
            font-weight: 600;
            font-size: 28px;
            text-align: center;
            color: #FFFFFF;
            text-shadow: 0px 2px 4px rgba(255,12,55,0.07);
    }
    .image-list {
            margin-left: 131px;
            .image-item {
                margin-bottom: 6px;
            }
            .image-item:first-child {
                margin-top: 6px;
            }
            .face-image {
                position: relative;
                width: 108px;
                height: 131px;
                border-radius: 3px;
                border: 1px solid #F7636E;
                .delete-icon {
                    position: absolute;
                    top:110px;
                    right: 8px;
                }
            }
            .wait-add-image {
                margin-top: 6px;
                width: 108px;
                height: 131px;
                border-radius: 3px;
                border: 1px dashed #F7636E;
                .add-icon {
                    height: 11px;
                    width: 11px;
                    margin-top: 60px;
                    margin-left: 49px;
                }
            }
            .num-tips {
                margin-top: 7px;
                margin-left: 10px;
                font-weight: 400;
                font-size: 11px;
                color: #E5484D;
                i {
                    margin-right: 5px;
                }
            }
    }
    .identify-content {
        position: absolute;
        margin: 230px 0 0 calc(50% - 228px);
    }
    .identify-block {
        position: relative;
        width: 457px;
        height: 421px;
        .external-block {
            width: 457px;
            height: 457px;
            overflow: hidden;
            border-radius: 50%;
            background: linear-gradient(to bottom, #F7636E 50%,  rgba(247,99,110,0.2) 50%);
            animation: rotate 3s linear infinite;
        }
        .external-block-error {
            background: #F7636E;
        }
        @keyframes rotate {
            from {
            transform: rotate(0deg);
            }
            to {
            transform: rotate(360deg);
            }
        }
        .image-block {
            width: 441px;
            height: 441px;
            border-radius: 50%;
            position: absolute;
            top:8px;
            left: 8px;
            background-image: url(~@/assets/images/busImage/people.png);
            background-size: 115%; /* 背景图片覆盖整个元素 */
            background-repeat: no-repeat; /* 背景图片不重复 */
            background-position: center; /* 背景图片居中 */
        }
        .countdown-number {
            position: absolute;
            z-index: 100;
            top: calc(50% - 64px );
            left: calc(50% - 39px);
            font-size: 8em;
            font-weight: bold;
            color: #333;
            animation: blink 1s infinite; /* 应用动画 */
        }
        @keyframes blink {
            0%, 100% { opacity: 1; }
            50% { opacity: 0.5; } /* 使数字在闪烁之间变暗 */
        }
    }
    .tips {
        width: 480px;
        margin: 48px auto 0 auto;
        &-info {
            font-weight: 600;
            font-size: 32px;
            text-align: center;
            margin-bottom: 48px;
            color: rgba(0,0,0,0.85);
            line-height: 67px;
            letter-spacing: 17px;
        }
        &-list {
            display: flex;
            justify-content:space-around;
            .item {
                display: flex;
                flex-direction: column;
                align-items: center;
                &-icon {
                    width: 53px;
                    height: 53px;
                    margin-bottom: 11px;
                }
                &-text {
                    font-weight: 400;
                    font-size: 17px;
                    text-align: center;
                    color: rgba(0,0,0,0.45);
                    line-height: 24px;
                }
            }
        }
    }
    .btn-group {
        position: absolute;
        display: flex;
        flex-direction: column;
        top: 352px;
        right: 30px;
        .other-login {
            width: 263px;
            height: 80px;
            line-height: 80px;
            margin-bottom: 32px;
            background: #FFEEF1;
            border-radius: 8px 0px 0px 8px;
            font-weight: 600;
            font-size: 28px;
            text-align: center;
            color: #F7636E;
        }
        .retry-btn {
            width: 263px;
            height: 80px;
            line-height: 80px;
            background: linear-gradient( 135deg, #C62D2F 0%, #B23B34 100%);
            border-radius: 8px 0px 0px 8px;
            font-weight: 600;
            font-size: 28px;
            text-align: center;
            color: #fff;
        }
    } 
    .cancle-btn {
        position: absolute;
        padding: 17px 22px;
        top: 42px;
        right: 40px;
        background: rgba(239,239,239,0.5);
        border-radius: 8px;
        font-size: 32px;
        text-align: center;
        color: #FFFFFF;
    }

</style>

